// import axios, { AxiosError, AxiosResponse } from 'axios';
// import { clearToken, storeToken } from '../utils/main-utils';
// type MyErrorResponse = {
//   code: string;
//   message: string;
// }

// const getToken = () => {
//   return localStorage.getItem('accessToken');
// };

// const api = axios.create({
//   baseURL: (window as any).REACT_APP_BASE_API_URL,
//   headers: {
//     'Cache-control': 'no-cache',
//   },
// });

// api.interceptors.request.use(function (config: any) {
//   const token = getToken();
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// const goToLogin = () => {
//   clearToken();
//   window.location.href = '/';
// };

// api.interceptors.response.use(
//   function (response: AxiosResponse) {
//     const token = response.headers['x-access-token'];
//     if (token) {
//       storeToken(token);
//     }
//     return response;
//   },
//   function (error: AxiosError<MyErrorResponse>) {
//     const shouldRedirectToLogin = error.response?.data?.code === 'auth_failed';
//     if (shouldRedirectToLogin) {
//       goToLogin();
//     }
//     return Promise.reject(error);
//   },
// );

// export default api;


import axios, { AxiosError, AxiosResponse } from 'axios';
import { clearToken, storeToken } from '../utils/main-utils';

type MyErrorResponse = {
  code: string;
  message: string;
};

type AccessTokenResponse = {
  'x-access-token': string;
};

const getToken = (): string | null => localStorage.getItem('accessToken');

const api = axios.create({
  baseURL: (window as any).REACT_APP_BASE_API_URL,
  headers: {
    'Cache-Control': 'no-cache',
  },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response: AxiosResponse<unknown>) => {
    const newToken = (response.headers as AccessTokenResponse)['x-access-token'];
    if (newToken) {
      storeToken(newToken);
    }
    return response;
  },
  (error: AxiosError<MyErrorResponse>) => {
    if (error.response?.data?.code === 'auth_failed') {
      clearToken();
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
